function isBlank(value: string | null | undefined): boolean {
    return !value || value.trim() === "";
}

/**
 * Whether this half of a username/password pair is the missing one. The pair
 * must be both blank (the organization's credentials apply) or both set, so a
 * field is missing only when it is blank and its partner is not.
 */
export function credentialMissing(value: string | null | undefined, partner: string | null | undefined): boolean {
    return isBlank(value) && !isBlank(partner);
}
